import DiceRollValues from "./DiceRollValues";

//Props typings
export * from "./DiceRollValues";

export { DiceRollValues };

export default DiceRollValues;
